export type TimeEntry = {
  id: string;
  type: TimeEntryType;
  from: string;
  to: string;
  message: string;
  orderId: string;
  state: TimeEntryState;
  createdAt: string;
  inspectedAt: string;
  userName: string;
  userId: string;
  controllerMessage: string;
  controllerName: string;
  controllerId: string;
  processed: boolean;
  userHogiaNumber: string | null;
};

export const TimeEntryTypes = {
  SickLeave: 1,
  PaidVacation: 2,
  ChildCare: 3,
  UnpaidVacation: 4,
  Overtime: 5,
  RelativeCare: 6,
  ParentalLeave: 7,
} as const;

export type TimeEntryType = typeof TimeEntryTypes[keyof typeof TimeEntryTypes];

export type TimeEntryState = "PENDING" | "APPROVED" | "REJECTED";
